import { useEffect, useState } from "react";
import apiCalls from "src/api/apiCalls";

const useApi = () => {
    const [awaitingResponse, setAwaitingResponse] = useState({});
    const [data, setData] = useState({});
    const [error, setError] = useState({});

    useEffect(() => {
        return () => {
            cleanState();
        };
    }, []);

    const cleanState = () => {
        setAwaitingResponse({});
        setData({});
        setError({});
    };

    const updateStateOnSuccess = (dataFor, responseData) => {
        setData(prev => ({ ...prev, [dataFor]: responseData }));
    };

    const updateStateOnError = (dataFor, errorResponse) => {
        setError(prev => ({ ...prev, [dataFor]: errorResponse }));
    };

    const executeFetchMethod = async (fetchMethod, hasFetchParams, fetchParams) => {
        return hasFetchParams ? await fetchMethod(...fetchParams) : await fetchMethod();
    };

    const executeFetchDetails = async (fetchDetails) => {
        const response = fetchDetails.options
            ? await fetch(fetchDetails.url, fetchDetails.options)
            : await fetch(fetchDetails.url);
        const data = await response.json();
        return { ...response, data };
    };

    const handleApi = async (fetchMethod, fetchDetails, dataFor, hasFetchParams, fetchParams, shouldClear) => {
        if (!dataFor) return;

        if (shouldClear) cleanState();

        setAwaitingResponse(prev => ({ ...prev, [dataFor]: true }));

        let response;
        try {
            if (fetchMethod && !fetchDetails) {
                response = await executeFetchMethod(fetchMethod, hasFetchParams, fetchParams);
            } else if (!fetchMethod && fetchDetails) {
                response = await executeFetchDetails(fetchDetails);
            }

            if (response?.ok) {
                updateStateOnSuccess(dataFor, response.data);
            } else {
                updateStateOnError(dataFor, apiCalls.isErrorDispaly(response?.data || response));
            }
        } catch (err) {
            setError(prev => ({ ...prev, [dataFor]: err?.message || err.toString() }));
        } finally {
            setAwaitingResponse(prev => ({ ...prev, [dataFor]: false }));
        }
    };

    return { awaitingResponse, data, error, handleApi };
};

export default useApi;
